import React from 'react';
import { DeleteOutlined, DiffOutlined, DownloadOutlined, ShareAltOutlined } from '@ant-design/icons';
import { RevButton } from '../Button';
import styles from './ActionButtons.module.scss';

interface ActionButtonsProps {
  // Permissions
  canDelete: boolean;
  canShare: () => boolean;
  canDownload: () => boolean;
  canCompare: () => boolean;
  canMultiSelect: () => boolean;
  
  // Data
  selectedItems?: Set<number>;
  fileDetail?: any;
  currentEntry?: any;
  
  // Handlers
  onDelete: () => void;
  onCompare: () => void;
  onCopyUrl?: () => void; // Artık kullanılmıyor; Copy Link Share modal içinde
  onDownload?: () => void;
  onShare: () => void;
  
  // Options
  hideDownload?: boolean;
  downloadLoading?: boolean;
  /** Share sadece sağ tık ve ... menüsünde; footer'da gösterme */
  showShare?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  canDelete,
  canShare,
  canDownload,
  canCompare,
  canMultiSelect,
  selectedItems,
  fileDetail,
  currentEntry,
  onDelete,
  onCompare,
  onCopyUrl: _onCopyUrl,
  onDownload,
  onShare,
  hideDownload,
  downloadLoading,
  showShare = true
}) => {
  const isMultiSelectDisabled = () => {
    return selectedItems && selectedItems.size > 1 && !canMultiSelect();
  };

  return (
    <div className={styles.buttonsContainer}>
      {canDelete && (
        <RevButton
          className={styles.iconOnlyAction}
          icon={<DeleteOutlined />}
          onClick={onDelete}
          disabled={((!selectedItems || selectedItems.size === 0) && !fileDetail && !currentEntry) || isMultiSelectDisabled()}
          aria-label="Delete"
          title="Delete"
        />
      )}

      {canDownload() && !hideDownload && (
        <RevButton
          className={styles.downloadAction}
          icon={<DownloadOutlined />}
          onClick={onDownload}
          disabled={(!selectedItems || selectedItems.size === 0) && !fileDetail && !currentEntry}
          loading={downloadLoading}
          aria-label="Download"
          title="Download"
        >
          <span className={styles.downloadLabel}>Download</span>
        </RevButton>
      )}

      {canCompare() && (
        <RevButton
          className={styles.compareButton}
          icon={<DiffOutlined />}
          onClick={onCompare}
          disabled={isMultiSelectDisabled()}
        >
          Compare
        </RevButton>
      )}

      {canShare() && showShare && (
        <RevButton
          icon={<ShareAltOutlined />}
          className={`${styles.shareButton} ${styles.shareAction}`}
          onClick={onShare}
          disabled={(!selectedItems || selectedItems.size === 0) || (selectedItems && selectedItems.size > 1)}
          aria-label="Share"
          title="Share"
        >
          <span className={styles.shareLabel}>Share</span>
        </RevButton>
      )}
    </div>
  );
};

export default ActionButtons; 